"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getReactSelectStyles = getReactSelectStyles;
exports.isStringAndNotEmpty = isStringAndNotEmpty;

var _reactDeviceDetect = require("react-device-detect");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function getReactSelectStyles() {
  var additionalStyles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread(_objectSpread({}, additionalStyles), {}, {
    valueContainer: function valueContainer(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        flex: _reactDeviceDetect.isIE ? '1 1 auto' : '1 1 0'
      });
    }
  });
}

function isStringAndNotEmpty(value) {
  if (!value) {
    return false;
  }

  return typeof value === 'string' || value instanceof String;
}